class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
    const filterbtn = document.querySelectorAll('.filter-button');
    const filterclose = this.querySelector('.filter-close');
    const sortbtn = this.querySelector('.sort-button');
    const showbtn = this.querySelector('.show-button');
    if(filterbtn){
      document.querySelectorAll('.filter-button').forEach((filter) => {
        filter.addEventListener('click',function(e){
          e.preventDefault();
          if(document.querySelectorAll('.filter-inr-wrap')){
            document.querySelectorAll('.filter-inr-wrap').forEach((content) => {
              if(content.querySelector("ul")){
                content.style.maxHeight = content.querySelector("ul").scrollHeight + "px";
              }else if(content.querySelector(".rangeclswrap")){
                content.style.maxHeight = content.querySelector(".rangeclswrap").scrollHeight + "px";
              }
            })
          }
          // let right = window.innerWidth - document.body.clientWidth
          // if(document.querySelector('body').classList.contains('open-filter')){
          //   document.querySelector('body').style.paddingRight = ''
          //   document.querySelector('main').style.width = ''
          // }else{
          //   document.querySelector('body').style.paddingRight = right+'px'
          //   document.querySelector('main').style.width = 'calc(100% + '+right+'px)'
          // }
          document.querySelector('body').classList.toggle('open-filter');
          document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search','filter-sticky');

          if(window.innerWidth < 992){
            // document.querySelector('.filter-sort').classList.remove('active');
            // document.querySelector('.filter-sort .filter-inr-wrap').style.maxHeight = '';
            document.querySelectorAll('.filter-wrap .facet-list').forEach((filterWrap) => {
              filterWrap.classList.remove('active');
              filterWrap.querySelector('.filter-inr-wrap').style.maxHeight = '';
            })
          }
        });
      })
    }
    if (filterclose) filterclose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.querySelectorAll('.facet-list h3')){
        document.querySelectorAll('.facet-list h3').forEach((filterAcco) => {
          filterAcco.addEventListener('click',function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            if(filterAcco.closest('.facet-list').classList.contains("active")){
              filterAcco.closest('.facet-list').classList.remove("active");
              const content = filterAcco.closest('.facet-list').querySelector(".filter-inr-wrap");
              content.style.maxHeight = '0px';
            }else{
              filterAcco.closest('.facet-list').classList.add("active");
              const content = filterAcco.closest('.facet-list').querySelector(".filter-inr-wrap");
              if(content.querySelector("ul")){
                content.style.maxHeight = content.querySelector("ul").scrollHeight + "px";
              }else if(content.querySelector(".rangeclswrap")){
                content.style.maxHeight = content.querySelector(".rangeclswrap").scrollHeight + "px";
              }
            }
          })
        })
      }
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
    console.log('count',count);
    document.querySelector('.coll-main-count').textContent = count;
    document.querySelector('.filter-total-count').textContent = count;
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    let count = 0;
    facetDetailsElements.forEach((filter) => {
      if(filter.classList.contains('filter-list')){
        filter.querySelectorAll('ul li.active').forEach((index,list) => {
          count++;
        });
      }
    });
    if(count > 0){
      document.querySelectorAll('.filter-count').forEach((filterCount) => {
        filterCount.textContent = count;
        filterCount.style.display = 'flex';
      })
    }else{
      document.querySelectorAll('.filter-count').forEach((filterCount) => {
        filterCount.style.display = 'none';
      })
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event) {    
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function rangePrice(params) {
  var lowerSlider = document.querySelector("#lower"),
    upperSlider = document.querySelector("#upper"),
    lowerVal = parseInt(lowerSlider.value),
    upperVal = parseInt(upperSlider.value);
  upperSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    maxVal = parseInt(lowerSlider.getAttribute('max'));
    if(maxVal == upperVal){
      document.querySelector('.r_range_position').classList.remove('active')
    }else{
      document.querySelector('.r_range_position').classList.add('active')
    }
    document.querySelector(".nextsetval").textContent = upperVal
    document.querySelector(".prevtsetval").textContent = lowerVal
    if (upperVal < lowerVal + 4) {
      lowerSlider.value = upperVal - 4;
      if (lowerVal == lowerSlider.min) {
        upperSlider.value = 4;
      }
    }
    let rr_slider = document.querySelector(".price-right");
    let rr_val = rr_slider.value;
    let rr_width = rr_slider.clientWidth - 15;
    let rr_min = rr_slider.getAttribute("min");
    let rr_max = rr_slider.getAttribute("max");
    let rr_percent = ((rr_val - rr_min) / (rr_max - rr_min)) * 100;
    let rr_offset = -3;
    let rr_newPosition = rr_width * rr_percent + rr_offset;
    // document.querySelector('.r_range_position').style.left = rr_newPosition;
  };
  lowerSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    minVal = parseInt(upperSlider.getAttribute('min'));
    if(minVal == lowerVal){
      document.querySelector('.l_range_position').classList.remove('active')
    }else{
      document.querySelector('.l_range_position').classList.add('active')
    }
    document.querySelector(".prevtsetval").textContent = lowerVal
    document.querySelector(".nextsetval").textContent = upperVal
    if (lowerVal > upperVal - 4) {
      upperSlider.value = lowerVal + 4;
      if (upperVal == upperSlider.max) {
        lowerSlider.value = parseInt(upperSlider.max) - 4;
      }
    }
    let rl_slider = document.querySelector(".price-left");
    let rl_val = rl_slider.value;
    let rl_width = rl_slider.clientWidth - 15;
    let rl_min = rl_slider.getAttribute("min");
    let rl_max = rl_slider.getAttribute("max");
    let rl_percent = ((rl_val - rl_min) / (rl_max - rl_min)) * 100;
    let rl_offset = -3;
    let rl_newPosition = rl_width * rl_percent + rl_offset;
    // document.querySelector('.l_range_position').style.left = rl_newPosition;
  };
}
if(document.querySelector(".rangecls")){
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()